import React from "react"
import tippy from "tippy.js"

import {MC} from './MC.js'

class Menu extends React.Component {

  constructor(props) {
    super(props)
    this.onclick = this.onclick.bind(this)
    this.handleRootMouseEnter = this.handleRootMouseEnter.bind(this)
    this.handleRootMouseLeave = this.handleRootMouseLeave.bind(this)
    this.menuRef = React.createRef()  
  }

  componentDidMount() {
    if (!MC.isModelerActive(this.props.data)) {
      let escape = MC.getFieldParamBooleanValue(this.props.data.param, '@escapeTooltipHtml')
      tippy('[data-tippy-content]', {arrow: true, delay: 400, animation: 'scale', theme: 'light-border', allowHTML: !escape})
      document.addEventListener('click', this.handleOutsideClick, false)
    }
  }

  componentWillUnmount() {
    if (!MC.isModelerActive(this.props.data)) {
      document.removeEventListener('click', this.handleOutsideClick, false)
    }
  }

  recalculateActiveKey(activeKey) {
    if (!MC.getFieldParamBooleanValue(this.props.data.param, '@dropdownSubMenu') && MC.getFieldParamBooleanValue(this.props.data.param, '@vertical')) {
      let items = MC.getFieldParamValue(this.props.data.param, 'items')
      if (Array.isArray(items) && activeKey) {
        for (let item of items) {
          let activeItem = false
          if (Array.isArray(item.items)) {
            activeItem = item.items.find((subitem) => {
              let activeSubItem = false
              if (Array.isArray(subitem.items)) {
                activeSubItem = subitem.items.find((ssubitem) => {
                  return ssubitem.key && ssubitem.key == activeKey
                })
              }
              if (subitem.key && subitem.key == activeKey || activeSubItem) {
                subitem.active = true
                subitem.opened = true
                return true
              }
              return false
            })
          }
          if (item.key && item.key == activeKey || activeItem) {
            item.active = true
            item.opened = true
          }
        }
      }
    }
    this.props.data.activeKeyWasRecalculated = true
    this.activeKey = activeKey
  }

  handleOutsideClick = (e) => {
    if (MC.getFieldParamBooleanValue(this.props.data.param, '@dropdownSubMenu') || !MC.getFieldParamBooleanValue(this.props.data.param, '@vertical')) {
      if (this.menuRef.current.contains(e.target) || e.target.offsetParent === null) {
        return
      }
      this.closeDropDown()
    }
  }

  getItemByIndex(index) {
    index = index.split("-")
    let item = MC.getFieldParamValue(this.props.data.param, 'items')[index.shift()]
    while (index.length > 0) {
      item = item.items[index.shift()]
    }
    return item
  }

  closeDropDown() {
    let items = MC.getFieldParamValue(this.props.data.param, 'items')
      if (Array.isArray(items) && items.length > 0) {
        for (let item of items) {
          if (item.opened) {
            item.opened = false
            if (Array.isArray(item.items) && item.items.length > 0) {
              for (let sitem of item.items) {
                if (sitem.opened) {
                  sitem.opened = false
                  break
                }
              }  
            } 
            break
          }  
        }  
      }
      this.forceUpdate()
  }

  onclick(e) {
    if (MC.eventHasKey(e)) {
      return
    }
    let field = this.props.data
    let item = this.getItemByIndex(e.currentTarget.dataset.i)
    let behavior = MC.getFieldParamValue(field.param, '@behavior')
    if (behavior != 'url' || item.enabled == false) {
      e.preventDefault()
    }
    e.stopPropagation()
    if (item.enabled == false) {
      return
    }
    if (Array.isArray(item['items']) && item['items'].length > 0 && item['items'][0] && item['items'][0].title) {
      if (!MC.getFieldParamBooleanValue(field.param, '@dropdownSubMenu')) {
        if (behavior == 'url' && !MC.isNull(item.url)) {
          return
        }
        item.opened = !item.opened
        this.forceUpdate()
      }
    } else {
      if (MC.getFieldParamBooleanValue(this.props.data.param, '@dropdownSubMenu') || !MC.getFieldParamBooleanValue(this.props.data.param, '@vertical')) {
        this.closeDropDown()
      }
      if (behavior == 'url') {
        if (!MC.isNull(item.url)) {
          this.props.data.flow.reactFlow().routeTo(e, item.url)
          return
        }
      } else {
        MC.putFieldParamValue(this.props.data.param, '@activeKey', item.key)
        MC.handleEvent(field, 'change')
        this.forceUpdate()
        if (behavior == 'dialog') {
          field.flow.callDialog(field)
        } else {
          field.flow.handleSubmit(field)
        }
      }
    }
  }

  handleRootMouseEnter(e) {
    const asDropdown = MC.getFieldParamBooleanValue(this.props.data.param, '@dropdownSubMenu')
    if (asDropdown) {
      let item = this.getItemByIndex(e.currentTarget.dataset.i)
      if (Array.isArray(item.items) && item.items.length > 0) {
        item.opened = true
        this.forceUpdate()
      }
    }
  }

  handleRootMouseLeave(e) {
    const asDropdown = MC.getFieldParamBooleanValue(this.props.data.param, '@dropdownSubMenu')
    if (asDropdown) {
      let item = this.getItemByIndex(e.currentTarget.dataset.i)
      if (Array.isArray(item.items) && item.items.length > 0) {
        item.opened = false
        this.forceUpdate()
      }
    }
  }

  buildSubmenu(item, rooti) {
    let submenu = ""
    let params = this.props.data.param
    let activeKey = MC.getFieldParamValue(params, '@activeKey')
    if (MC.isNull(rooti) && !MC.isNull(activeKey)) {
      if (this.activeKey !== activeKey || !this.props.data.activeKeyWasRecalculated) {
        this.recalculateActiveKey(activeKey)
      }
    }
    if (Array.isArray(item['items']) && item['items'].length > 0) {
      if (item.opened || MC.isNull(rooti)) {
        let asDropdown = MC.getFieldParamBooleanValue(params, '@dropdownSubMenu')
        let vertical = MC.getFieldParamBooleanValue(params, '@vertical')
        let iconPlacement = MC.getFieldParamValue(params, '@iconPlacement') || 'left'
        let items = []
        for (let i=0; i<item['items'].length; i++) {
          let strI = !MC.isNull(rooti) ? rooti + '-' + i : i
          let propItem = item['items'][i]
          let siconLeft = null
          let siconRight = null
          if (typeof propItem.icon == 'string') {
            if (iconPlacement == 'right') {
              siconRight = <span className="icon-span-right"><i className={MC.buildIconClass(propItem.icon)}/></span>
            } else {
              siconLeft = <span className="icon-span-left"><i className={MC.buildIconClass(propItem.icon)}/></span>
            }
          }
          let submenu = this.buildSubmenu(propItem, strI)
          let active = propItem.key && activeKey && propItem.key == activeKey
          let cls = MC.classes('ui', {'active': active, 'visible': submenu && (asDropdown || !vertical), 'opened': submenu && !asDropdown, 'dropdown': submenu && (asDropdown || !vertical), 'disabled': propItem.enabled == false}, propItem.cssclass, 'item curpointer')
          let tooltip = propItem.tooltip ? propItem.tooltip : null
          let href = null
          if (!MC.isNull(propItem.url) && propItem.url !== '' || propItem.url === '' && behavior == 'url') {
            href = propItem.url
          }
          let ItemTag = submenu ? "div" : "a"
          let title = <React.Fragment>{siconLeft}{propItem.title}{siconRight}</React.Fragment>
          if (submenu && href) {
            title = <a href={href} className={MC.classes({'active': active})}>{title}</a>
            href = null
          }
          items.push(
            <ItemTag className={cls} href={href} onClick={this.onclick} data-i={strI} key={'item' + strI} data-tippy-content={tooltip} onMouseEnter={this.handleRootMouseEnter} onMouseLeave={this.handleRootMouseLeave}>
              {title}
              {submenu}
            </ItemTag>)
        }
        let mcls = 'menu transition visible'
        let ref = null
        if (MC.isNull(rooti)) {
          ref = this.menuRef
          mcls = MC.classes('ui menu', MC.getFieldParamBooleanValue(params, '@fitWidth') ? 'fluid' : 'compact', {'vertical': MC.getFieldParamBooleanValue(params, '@vertical')}, MC.getFieldParamValue(params, '@cssClass'))
        }
        submenu = <div className={mcls} ref={ref}>{items}</div>
      }
    }
    return submenu
  }

  render() {
    return this.buildSubmenu(this.props.data.param, null)
  }
}

export default Menu